export { ImageBehindText } from './ImageBehindText';
